import localeText from "../../../locale";

export const ADMIN_ROLES = {
  ADMIN: "Admin",
  ACCOUNTANT: "Accountant",
};

// Seções do menu do novo admin. Cada item aponta para as mesmas URLs do admin clássico,
// assim links e favoritos continuam válidos nas duas versões.
// `roles` ausente = apenas Admin.
const buildMenu = () => [
  {
    key: "main",
    title: localeText("adminPanelSectionMain"),
    items: [
      {
        key: "home",
        label: localeText("adminDashboard"),
        icon: "pi pi-home",
        to: "/dashboard",
        exact: true,
      },
    ],
  },
  {
    key: "users",
    title: localeText("users"),
    items: [
      {
        key: "userLists",
        label: localeText("adminPanelUserLists"),
        icon: "pi pi-users",
        items: [
          { key: "managers", label: "Managers", to: "/dashboard-listareamanagers" },
          { key: "partners", label: "Partners", to: "/dashboard-listbusinesspartners" },
          { key: "customers", label: "Customers", to: "/dashboard-listspecialcustomers" },
          { key: "promoters", label: "Promoters", to: "/dashboard-listsalepromoters" },
          { key: "sellers", label: "Sellers", to: "/dashboard-listsellers" },
        ],
      },
      {
        key: "bankTransfers",
        label: localeText("bankTransfers"),
        icon: "pi pi-money-bill",
        to: "/dashboard-banktransfers",
      },
      {
        key: "address",
        label: localeText("adminAddressMenu"),
        icon: "pi pi-map-marker",
        to: "/dashboard-address",
      },
      {
        key: "subnets",
        label: `Whitelabel · ${localeText("subnets")}`,
        icon: "pi pi-sitemap",
        to: "/dashboard-whitelabel-users",
      },
    ],
  },
  {
    key: "sales",
    title: localeText("adminPanelSectionSales"),
    items: [
      {
        key: "orders",
        label: localeText("orders"),
        icon: "pi pi-shopping-cart",
        to: "/dashboard-listorders",
        activePaths: ["/dashboard-purchasesdetails"],
      },
      {
        key: "pendings",
        label: localeText("pendingIssues"),
        icon: "pi pi-exclamation-circle",
        to: "/dashboard-pendings",
      },
      {
        key: "physicalStores",
        label: localeText("physicalStores"),
        icon: "pi pi-building",
        to: "/dashboard-listphysicalstores",
      },
      {
        key: "scontiposte",
        label: localeText("adminChannelMenu"),
        icon: "pi pi-percentage",
        to: "/dashboard-scontiposte",
      },
    ],
  },
  {
    key: "catalog",
    title: localeText("adminPanelSectionCatalog"),
    items: [
      {
        key: "products",
        label: localeText("adverts"),
        icon: "pi pi-box",
        to: "/dashboard-listproducts",
      },
      {
        key: "categories",
        label: localeText("adminCatalogCategories"),
        icon: "pi pi-tags",
        to: "/dashboard-listcategory",
        activePaths: ["/dashboard-newcategories"],
      },
      {
        key: "subcategories",
        label: localeText("adminCatalogSubcategories"),
        icon: "pi pi-tag",
        to: "/dashboard-listsubcategories",
        activePaths: ["/dashboard-newsubcategory"],
      },
      {
        key: "brands",
        label: localeText("brands"),
        icon: "pi pi-verified",
        to: "/dashboard-listbrands",
        activePaths: ["/dashboard-newbrands"],
      },
      {
        key: "types",
        label: localeText("types"),
        icon: "pi pi-th-large",
        to: "/dashboard-listtypes",
        activePaths: ["/dashboard-newtypes"],
      },
      {
        key: "bangood",
        label: "Bangood",
        icon: "pi pi-globe",
        to: "/dashboard-bangood",
      },
    ],
  },
  {
    key: "finance",
    title: localeText("adminPanelSectionFinance"),
    items: [
      {
        key: "withdrawRequests",
        label: localeText("withdrawRequests"),
        icon: "pi pi-arrow-circle-up",
        to: "/dashboard-listwithdrawrequests",
      },
      {
        key: "excWithdrawRequests",
        label: localeText("excWithdrawRequests"),
        icon: "pi pi-wallet",
        to: "/dashboard-listexcwithdrawrequests",
      },
      {
        key: "paidSubscriptions",
        label: localeText("paidSubscriptions"),
        icon: "pi pi-id-card",
        to: "/dashboard-paidsubscriptions",
      },
    ],
  },
  {
    key: "reports",
    title: localeText("reports"),
    roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.ACCOUNTANT],
    items: [
      {
        key: "paidOrdersReport",
        label: localeText("paidOrdersReport"),
        icon: "pi pi-chart-bar",
        to: "/dashboard-report-paidorders",
      },
      {
        key: "completedWithdrawalsReport",
        label: localeText("completedWithdrawalsReport"),
        icon: "pi pi-chart-line",
        to: "/dashboard-report-completedwithdrawals",
      },
      {
        key: "paidSubscriptionsReport",
        label: localeText("paidSubscriptionsReport"),
        icon: "pi pi-file",
        to: "/dashboard-report-paidsubscriptions",
      },
    ],
  },
  {
    key: "storefront",
    title: localeText("adminPanelSectionStorefront"),
    items: [
      {
        key: "banners",
        label: localeText("adminPanelBanners"),
        icon: "pi pi-images",
        items: [
          { key: "mainBanner", label: localeText("principalBanner"), to: "/dashboard-banners" },
          { key: "subBanner1", label: "Sub Banner 1", to: "/dashboard-subbanners1" },
          { key: "subBanner2", label: "Sub Banner 2", to: "/dashboard-subbanners2" },
          { key: "subBanner3", label: "Sub Banner 3", to: "/dashboard-subbanners3" },
        ],
      },
      {
        key: "integrations",
        label: localeText("integrations"),
        icon: "pi pi-cog",
        to: "/dashboard-metaads",
        activePaths: ["/dashboard-gtm"],
      },
    ],
  },
];

export const getAdminPanelMenu = (userType) =>
  buildMenu().filter((section) => (section.roles || [ADMIN_ROLES.ADMIN]).includes(userType));

// Todos os links folha do menu, usados para achar o título da página atual
export const flattenMenuLinks = (menu) =>
  menu.flatMap((section) =>
    section.items.flatMap((item) =>
      item.items
        ? item.items.map((child) => ({ ...child, parentLabel: item.label, icon: item.icon }))
        : [item],
    ),
  );

export const isPathActive = (link, pathname) => {
  if (link.exact) return pathname === link.to;
  const paths = [link.to, ...(link.activePaths || [])];
  return paths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
};
